<template>

    <span class="">
        <i class="bi bi-check-lg text-success" v-if="value"></i>
        <i class="bi bi-x-lg text-danger" v-else></i>
    </span>

</template>


<script>
    export default {
        props: [
            'value',
        ],
        data() {
            return {

            }
        }
    }
</script>